import DownloadIcon from "@/assets/svg/16/DownloadIcon";
import textconfig from "@/textconfig";
import clsx from "clsx";
import Image from "next/image";
import Link from "next/link";
import styles from "./recipes.module.css";
import { Recipe } from "./UI/ClientUI";

type RecipeCard = {
  recipeCard: Recipe;
  index: number;
};

export const RecipeCard = ({ recipeCard, index }: RecipeCard) => {
  const translations = textconfig.account.recipes;
  return (
    <div
      className={clsx(styles.grid, styles.recipe)}
      key={recipeCard?.description?.sku + "--" + index}
    >
      <div className={clsx(styles.tab__content, styles.image__tab)}>
        <Image
          src={recipeCard?.gallery?.image?.uri || ""}
          alt={recipeCard?.gallery?.image?.alt ?? ""}
          className={styles.product__image}
          width={80}
          height={100}
        />
      </div>
      <p className={clsx(styles.tab__content, styles.product__number)}>
        {recipeCard?.description?.sku}
      </p>
      <Link
        href={recipeCard.core?.slug ?? "#"}
        className={clsx(styles.tab__content, styles.product__name)}
      >
        {recipeCard?.description?.name}
      </Link>
      <div className={styles.tab__content}>
        <div className={styles.download}>
          {!!recipeCard?.download?.uri && recipeCard?.download?.lastModified ? (
            <>
              <Link href={recipeCard?.download?.uri ?? "#"} download>
                <DownloadIcon />
                <span>Last ned</span>
              </Link>
              <span className={styles.download__info}>
                {`Sist oppdatert: ${recipeCard?.download.lastModified}`}
              </span>
            </>
          ) : (
            <p className={styles.missingPDF}>{translations.noPdfMessage}</p>
          )}
        </div>
      </div>
    </div>
  );
};
